import {Base} from "@/api/Base"

export class HolidayDelete extends Base {
    path = "holiday/delete"
}